import styled from '@emotion/styled';
import { flexCenterAll } from 'style';

export const Wrapper = styled.div<{ shrink?: boolean }>`
  width: 100%;
  height: ${(props) => (props.shrink ? 'auto' : 'calc(100vh - 100px)')};
  ${flexCenterAll};
  flex-direction: column;
`;
